import './toast.css';

import { CheckIcon, InformationCircleIcon, XCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import * as RadixToast from '@radix-ui/react-toast';
import parse from 'html-react-parser';

import { useTranslation } from '@/hooks/useTranslation';

import { Icon } from '../Icon';
import { IconButton } from '../IconButton';

interface ToastInterface {
    id: string;
    text: string;
    type: ToastType;
}

enum ToastType {
    ERROR = 'error',
    SUCCESS = 'success',
    INFO = 'info',
    WARNING ='warning'
}

const ToastVariants = {
    [ToastType.ERROR]: {
        bgClass: 'toast-error-bg-color',
        iconClass: 'toast-error-icon-color',
        prefixIcon: XCircleIcon,
        duration: 5000
    },

    [ToastType.INFO]: {
        bgClass: 'toast-info-bg-color',
        iconClass: 'toast-info-icon-color',
        prefixIcon: InformationCircleIcon,
        duration: 4000
    },
    [ToastType.SUCCESS]: {
        bgClass: 'toast-success-bg-color',
        iconClass: 'toast-success-icon-color',
        prefixIcon: CheckIcon,
        duration: 4000
    },
    [ToastType.WARNING]: {
        bgClass: 'toast-warning-bg-color',
        iconClass: 'toast-warning-icon-color',
        prefixIcon: CheckIcon,
        duration: 4000
    },
};

const Toast = ({
    toast,
    onClose,
}: {
    toast: ToastInterface;
    onClose: () => void;
}) => {
    const { t } = useTranslation();

    return (
        <div>
            <RadixToast.Root
                className={`toast-root ${
                    ToastVariants[toast.type].bgClass
                }`}
                duration={ ToastVariants[toast.type].duration}
                onOpenChange={() => onClose()}
            >
                <div className="tw-flex tw-items-start tw-justify-between">
                    <div className="tw-flex tw-items-start tw-gap-2">
                        <RadixToast.Title>
                            <Icon
                                className={
                                    ToastVariants[toast.type].iconClass
                                }
                                icon={
                                    ToastVariants[toast.type].prefixIcon
                                }
                                size='sm'
                            />
                        </RadixToast.Title>
                        <RadixToast.Description className="tw-text-t-sm tw-text-center">
                            {parse(t(toast.text))}
                        </RadixToast.Description>
                        <RadixToast.Action
                            className="toast-action tw-cursor-pointer tw-p-0"
                            asChild
                            altText={t('CLOSE')}
                        >
                            <IconButton
                                className="toast-close-btn"
                                size='sm'
                                icon={XMarkIcon}
                                onClick={onClose}
                            />
                        </RadixToast.Action>
                    </div>
                </div>
            </RadixToast.Root>
            <RadixToast.Viewport className="toast-viewport" />
        </div>
    );
};

export { Toast, type ToastInterface, ToastType };
